module.exports = __webpack_public_path__ + "img/9791191247053.0fa11945.jpg";